export const ProgressBar = ({
    now,
    label,
    className = '',
    height = 'h-6',
    bgColor = 'bg-neutral-200',
    barColor = 'bg-blue-500',
}: {
    now: number;
    className?: string;
    label?: string;
    height?: string;
    bgColor?: string;
    barColor?: string;
}) => {
    const safeNow = Math.max(0, Math.min(now, 100));

    return (
        <div
            className={`relative w-full ${height} rounded-full overflow-hidden ${bgColor} ${className}`}>
            <div
                className={`absolute top-0 left-0 h-full ${barColor} transition-all duration-300`}
                style={{width: `${safeNow}%`}}
            />

            <div className="absolute inset-0 flex items-center justify-center text-sm font-medium text-black dark:text-white pointer-events-none z-0">
                {label || `${safeNow}%`}
            </div>

            <div
                className="absolute inset-0 flex items-center justify-center text-sm font-medium text-white pointer-events-none z-10"
                style={{clipPath: `inset(0 ${100 - safeNow}% 0 0)`}}>
                {label || `${safeNow}%`}
            </div>
        </div>
    );
};
